const $ = require('jquery');

function style(src) {
  return new Promise((resolve, reject) => {
    $('<link>', { rel: 'stylesheet', type: 'text/css', 'href': src })
      .on('load', resolve)
      .on('error', reject)
      .appendTo('head')
  });
}

function script(src) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: src,
      cache: true,
      dataType: 'script'
    }).done(resolve).fail(reject);
  });
}

module.exports = { style, script };
